import { render, staticRenderFns } from "./SuspenseListFilter.vue?vue&type=template&id=69585541&scoped=true"
import script from "./SuspenseListFilter.vue?vue&type=script&lang=js"
export * from "./SuspenseListFilter.vue?vue&type=script&lang=js"
import style0 from "./SuspenseListFilter.vue?vue&type=style&index=0&id=69585541&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69585541",
  null
  
)

export default component.exports